exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".invoice-header-wrapper {\n  background-color: #f8f7fb;\n  padding-bottom: 10px; }\n  .invoice-header-wrapper img {\n    margin: 0 auto; }\n", ""]);

